import { render, staticRenderFns } from "./PasswordRemindChange.vue?vue&type=template&id=956f00da&scoped=true&"
import script from "./PasswordRemindChange.vue?vue&type=script&lang=ts&"
export * from "./PasswordRemindChange.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordRemindChange.vue?vue&type=style&index=0&id=956f00da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956f00da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VImg,VRow,VTextField})
